var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.796875,
    width: 25.0971,
    height: 25,
    fill: "url(#pattern0_907_6225)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_907_6225",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_907_6225",
    transform: "matrix(0.0332043 0 0 0.0333333 0.00193542 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_907_6225",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABQ0lEQVR4nO2WvUrEQBDHt0im8Brh0Gc4hMwERBAsrNUrfY8r7GzWYmYbG0t9GBstREFf4Brx4wm0FJVc9vZE7jZfeyk0f5hilk1+7D8zO1Gq078SEB/EKC9A8hUyYuJnSHhvIXiyITB0Bpcnz4mXA51GB3YqtKSmSlvdgX09X9ijoa2Of/S8t0eDg5HHDow8bg0MiYzc5ZDIqDWwGpi+2z8w/dbAgGboToxmuDQwpGa/zBCZV+WNwFUm1+8qrw/e0NBkEtUHp7KWt408LnzY847a4CjhbWvhZatgQDnKq1cu8pzPY+RXRXo1KBhsRCQ7dv3aXhSHaldHQPKW5T3U60Xg6n8gyHfZWpSaLSD+BOJ3hae9qe1A/FDGtVLgeQKSe/t9T7I8Jj6rWtW1BCQ3gHKrNvXKJE/kGJA//GC+agxWf03fTrAJ4SE8a1QAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/custom-icon.2e3ab118abbc8bde06d97af627fe101f.svg";
export { ForwardRef as ReactComponent };